import { useAppSelector } from '@customer/store/hooks';
import { useMemo } from 'react';
import {
  AllowedQueryParams,
  getFilterNamesFromFiltersList,
  getFiltersList,
  getRelevantFilters,
} from './utils';
import { FilterGroup, FilterName } from './types';
import { FiltersState } from '@customer/store/slices/filtersSlice';

export const useFilters = <FiltersSubset extends AllowedQueryParams = AllowedQueryParams>(
  filterGroup?: FilterGroup,
): FiltersSubset => {
  const savedFilters: FiltersState = useAppSelector(state => state.filters.saved);

  const filterNames = useMemo<FilterName[]>(() => {
    return filterGroup ? getFilterNamesFromFiltersList(getFiltersList(filterGroup)) : [];
  }, [filterGroup]);

  const relevantFilters = useMemo<FiltersSubset>(
    () => getRelevantFilters<FiltersSubset>(savedFilters, filterNames),
    [savedFilters, filterNames],
  );

  return relevantFilters;
};

export default useFilters;
